import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { AVAILABLE_LANGUAGES } from "@/i18n";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Globe } from "lucide-react";
import { toast } from "sonner";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n, t } = useTranslation();
  const { user, updateLanguage } = useAuth();
  const currentLang = i18n.language?.slice(0, 2) || "it";

  const handleChange = async (lang) => {
    if (lang === currentLang) return;
    if (user) {
      const r = await updateLanguage(lang);
      if (r.ok) toast.success(t("profile.language_saved"));
      else toast.error(r.error || "Errore");
    } else {
      await i18n.changeLanguage(lang);
    }
  };

  if (compact) {
    return (
      <Select value={currentLang} onValueChange={handleChange}>
        <SelectTrigger className="h-8 w-24 rounded-sm text-xs" data-testid="lang-switcher">
          <div className="flex items-center gap-1">
            <Globe className="h-3 w-3" />
            <SelectValue />
          </div>
        </SelectTrigger>
        <SelectContent>
          {AVAILABLE_LANGUAGES.map((l) => (
            <SelectItem key={l.code} value={l.code} data-testid={`lang-opt-${l.code}`}>
              <span className="mr-1">{l.flag}</span>{l.code.toUpperCase()}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  return (
    <Select value={currentLang} onValueChange={handleChange}>
      <SelectTrigger className="rounded-sm" data-testid="lang-switcher">
        <div className="flex items-center gap-2">
          <Globe className="h-4 w-4" />
          <SelectValue />
        </div>
      </SelectTrigger>
      <SelectContent>
        {AVAILABLE_LANGUAGES.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`lang-opt-${l.code}`}>
            <span className="mr-2">{l.flag}</span>{l.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
